import { IArrayMap } from '../models/array-map'
import { isEmpty } from './data'
import { stub } from '@adex/shared/utils/stub'


export function buildArrayMap<T>(keys: string[], defaultValue: T): IArrayMap<T> {
  const obj = {} as IArrayMap<T>
  for (let i = 0; i < keys.length; i++) {
    obj[keys[i]] = defaultValue
  }
  return obj
}

export function dropFieldsArrayMap<T>(arrayMap: IArrayMap<T>, fields: string[]): IArrayMap<T> {
  const obj = { ...arrayMap }
  for (let i = 0; i < fields.length; i++) {
    const field = fields[i]
    delete obj[field]
  }
  return obj
}

export function dropEmptyField<T extends object>(obj: T): Partial<T> {
  const newObj = {}
  const keys = Object.keys(obj)
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    if (isEmpty(obj[key])) continue
    newObj[key] = obj[key]
  }
  return newObj
}

export function buildArrayMapFromArray<T, R = T>(arr: T[], field: keyof T, callback: ((item: T) => R) = (stub as any)): IArrayMap<R> {
  const obj = {} as IArrayMap<R>
  for (let i = 0; i < arr.length; i++) {
    const item = arr[i]
    obj[item[field] as any] = callback(item)
  }
  return obj
}

export function buildArrayFromArrayMap<T>(arr: IArrayMap<T>): T[] {
  const keys = Object.keys(arr)
  const newArr: T[] = []
  for (let i = 0; i < keys.length; i++) {
    newArr.push(arr[keys[i]])
  }
  return newArr
}

export function forEachArrayMap<T>(arr: IArrayMap<T>, fn: (key: string) => void): void
export function forEachArrayMap<T>(arr: IArrayMap<T>, fn: (key: string, item: T) => void): void
export function forEachArrayMap<T>(arr: IArrayMap<T>, fn: (key: string, item: T, map: IArrayMap<T>) => void): void {
  // tslint:disable-next-line:forin
  for (const key in arr) {
    const item = arr[key]
    try {
      fn(key, item, arr)
    } catch (e) {
      console.error(e)
    }
  }
}
